import { twMerge } from 'tailwind-merge';

export const IconBook = ({ className, changeColorOnHover = false, size = '48', color = '#005DB7' }) => {

  return (
    <svg className={twMerge(changeColorOnHover && 'peer-hover:[&_path]:stroke-[#FCBC00] group-hover:[&_path]:stroke-[#FCBC00] dark:[&_path]:stroke-[#A9C7FF]', className)} width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 35.625C10.5 36.6527 10.9064 37.6383 11.6297 38.365C12.3531 39.0917 13.3342 39.5 14.3571 39.5H37.5V8.5H14.3571C13.3342 8.5 12.3531 8.90826 11.6297 9.63496C10.9064 10.3617 10.5 11.3473 10.5 12.375V35.625ZM10.5 35.625C10.5 34.5973 10.9064 33.6117 11.6297 32.885C12.3531 32.1583 13.3342 31.75 14.3571 31.75H37.5M18.2143 16.25H29.7857" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}